import { Box, Button, styled } from '@mui/material';

import { muiPalette } from '@/shared/general-theme';

export const ContentSection = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ErrorCode = styled(Box)(
  ({ theme }) => (
    {
      fontSize: '25rem',
      fontWeight: 'bold',
      color: muiPalette.grey[50],
      position: 'absolute',
      zIndex: 0,
      userSelect: 'none',
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        fontSize: '18.75rem',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '12.5rem',
      },
      opacity: 0.5,
    }
  ));

export const ContentBox = styled(Box)({
  zIndex: 1,
  textAlign: 'center',
});

export const StyledButton = styled(Button)(
  () => (
    {
      padding: '0.625rem 1.5rem',
      borderRadius: '1.25rem',
      textTransform: 'none',
      fontSize: '1rem',
      fontWeight: 'bold',
      backgroundColor: muiPalette.secondary.main,
      '&:hover': {
        backgroundColor: muiPalette.secondary.dark,
      },
    }
  ));